<template>
  <div class='CheckoutItem'>
    <div class="img">
      <img v-if="data.img.length" :src="api + data.img[0].img">
      <img-icon
      v-if="!data.img.length"
      :options="{ width: '40px', heigth: '40px', color: '#CCCCCC' }"
      />
      <div class="qtde">{{ data.qtda }}</div>
    </div>
    <div class="desc">
      {{ data.name }}
    </div>
    <div class="valor">
      {{ preco }}
    </div>
  </div>
</template>

<script>
import ImgIcon from '@/components/EnbPainel/Icons/ImgIcon'
import api from '@/mixins/api'
export default {
  name: 'CheckoutItem',
  components: { ImgIcon },
  props: ['data'],
  mixins: [api],
  computed: {
    preco () {
      if(this.data.oferta <= 0) {
        return (this.data.preco * this.data.qtda).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})
      }
      else {
        return (this.data.oferta * this.data.qtda).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})
      }
    }
  }
}
</script>

<style scoped>
.CheckoutItem {
  display: flex;
  margin-top: 2%;
  padding-bottom: 2%;
}

.img {
  width: 20%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

img {
  width: 70%;
  height: 70%;
}

.qtde {
  width: 25px;
  height: 25px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  background-color: #000000;
  position: absolute;
  margin-top: -48%;
  margin-left: 40%;
}

.desc {
  width: 60%;
  display: flex;
  align-items: center;
}

.valor {
  width: 20%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
